import React, { FunctionComponent, useEffect, useRef, useState } from 'react'

import { formatCurrencyNumber } from '../Money/Money'

export interface IncreasingNumberProps {
  finalNumber: number
  className?: string
  decimal?: number
  suffix?: string
}

export const IncreasingNumber: FunctionComponent<IncreasingNumberProps> =
  props => {
    const intervalRef = useRef<NodeJS.Timeout | null>(null)
    const currentValueRef = useRef(0)
    const [, forceRerender] = useState(false)

    useEffect(() => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
        intervalRef.current = null
      }

      const startValue = currentValueRef.current
      const targetValue = props.finalNumber
      const ANIMATION_STEPS = 30
      const ANIMATION_DURATION = 500
      const UPDATE_INTERVAL = ANIMATION_DURATION / ANIMATION_STEPS

      let currentStep = 0

      intervalRef.current = setInterval(() => {
        currentStep++
        const progress = currentStep / ANIMATION_STEPS
        const easedProgress = 1 - Math.pow(1 - progress, 3) // easeOutCubic

        currentValueRef.current =
          startValue + (targetValue - startValue) * easedProgress

        if (currentStep >= ANIMATION_STEPS) {
          currentValueRef.current = targetValue
          if (intervalRef.current) {
            clearInterval(intervalRef.current)
            intervalRef.current = null
          }
        }

        forceRerender(previousValue => !previousValue)
      }, UPDATE_INTERVAL)

      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current)
          intervalRef.current = null
        }
      }
    }, [props.finalNumber])

    return (
      <span className={props.className}>
        {formatCurrencyNumber(currentValueRef.current, props.decimal)}
        {props.suffix}
      </span>
    )
  }
